/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-this-in-sfc */
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import RangeSlider from "./SliderComponent";
import ColorPicker from "./ColorPicker";

export default function AmbientLight({
  currentConfig,
  applyAmbientLight,
  updateConfig,
}) {
  const convertColorValue = (value) => {
    let color = value;
    if (typeof currentConfig?.color === "number") {
      color = `#${Number(currentConfig?.color).toString(16).toUpperCase()}`;
    }

    return color;
  };

  const [intensityValue, setIntensityValue] = useState(
    currentConfig?.intensity ?? 0
  );
  return (
    <div className="ambientContainer">
      <div className="ambientHeader">
        <div className="ambientHeaderInfo">
          <div className="ambientTitle">Ambient Light Settings</div>
        </div>
      </div>
      <div className="formWrapper">
        <div className="intensity">
          <Form.Label>Intensity</Form.Label>
          <RangeSlider
            onSliderChange={(value) => {
              console.log("on ambient light slider", value);
              currentConfig.intensity = value;
              setIntensityValue(value);
              applyAmbientLight(currentConfig);
              updateConfig(currentConfig);
            }}
            onAfterChange={(value) => {
              currentConfig.intensity = value;
              setIntensityValue(value);
              applyAmbientLight(currentConfig);
            }}
            value={intensityValue}
          />
        </div>
        <div className="colorPickerContainer">
          <ColorPicker
            title="Ambient Color"
            color={convertColorValue(currentConfig?.color)}
            onColorChange={(value) => {
              console.log("on ambient light color picker", value);
              currentConfig.color = parseInt(value.slice(1), 16);
              applyAmbientLight(currentConfig);
              updateConfig(currentConfig);
            }}
          />
        </div>
      </div>
    </div>
  );
}
